import { render, staticRenderFns } from "./StyleStepColor.vue?vue&type=template&id=bb1a2b32&scoped=true"
import script from "./StyleStepColor.vue?vue&type=script&lang=js"
export * from "./StyleStepColor.vue?vue&type=script&lang=js"
import style0 from "./StyleStepColor.vue?vue&type=style&index=0&id=bb1a2b32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1a2b32",
  null
  
)

export default component.exports